module.exports = __webpack_public_path__ + "img/wx2.66fc5335.jpg";